import React from 'react';
import { BookOpen, Repeat, Eye, Users } from 'lucide-react';
export function FormsTips() {
  const tips = [{
    icon: BookOpen,
    title: 'Study the Form',
    description: 'Watch the video multiple times to understand the sequence and movements.'
  }, {
    icon: Repeat,
    title: 'Practice Regularly',
    description: 'Consistent practice is key to mastering each form and advancing through belt levels.'
  }, {
    icon: Eye,
    title: 'Focus on Details',
    description: 'Pay attention to stances, hand positions, and breathing throughout each movement.'
  }, {
    icon: Users,
    title: 'Ask Your Instructor',
    description: 'Bring questions to class and get personalized feedback on your technique.'
  }];
  return <section className="py-16 bg-slate-50" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="text-center mb-12" data-id="element-155">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-156">
            How to Use These Videos
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-157">
            Get the most out of your form practice with these helpful tips.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-158">
          {tips.map((tip, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 p-6 text-center" data-id="element-159">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-[#dc2626] rounded-full mb-4" data-id="element-160">
                <tip.icon className="h-6 w-6 text-white" data-id="element-161" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-162">
                {tip.title}
              </h3>
              <p className="text-sm text-slate-600" data-id="element-163">{tip.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}